import { getData } from '@/utils/axiosUtils';

export const getAvailNumberblocks = async (currentCompany) => {
    return await getData(`/company/${currentCompany}/numberblocks/available`);
};
